export default "__VITE_ASSET__DDpCCxnK__"